export const INTERNET_JOBS = [
  // 一、技术研发类（核心）
  { value: '前端开发工程师', label: '前端开发工程师' },
  { value: '后端开发工程师', label: '后端开发工程师' },
  { value: '全栈开发工程师', label: '全栈开发工程师' },
  { value: 'iOS开发工程师', label: 'iOS开发工程师' },
  { value: 'Android开发工程师', label: 'Android开发工程师' },
  { value: 'Flutter开发工程师', label: 'Flutter开发工程师' },
  { value: '小程序开发工程师', label: '小程序开发工程师' },
  { value: 'Web开发工程师', label: 'Web开发工程师' },
  { value: '游戏开发工程师', label: '游戏开发工程师' },

  // 二、算法/数据类
  { value: '算法工程师', label: '算法工程师' },
  { value: '数据工程师', label: '数据工程师' },
  { value: '数据分析师', label: '数据分析师' },
  { value: '机器学习工程师', label: '机器学习工程师' },
  { value: 'AI工程师', label: 'AI工程师' },
  { value: '大数据工程师', label: '大数据工程师' },
  { value: 'BI分析师', label: 'BI分析师' },

  // 三、测试/质量保障类
  { value: '测试工程师', label: '测试工程师' },
  { value: '自动化测试工程师', label: '自动化测试工程师' },
  { value: '性能测试工程师', label: '性能测试工程师' },
  { value: '安全测试工程师', label: '安全测试工程师' },
  { value: 'QA工程师（质量保障）', label: 'QA工程师（质量保障）' },

  // 四、运维/基础设施类
  { value: 'DevOps工程师', label: 'DevOps工程师' },
  { value: '运维工程师', label: '运维工程师' },
  { value: '云运维工程师', label: '云运维工程师' },
  { value: '网络工程师', label: '网络工程师' },
  { value: '安全工程师', label: '安全工程师' },

  // 五、产品类
  { value: '产品经理', label: '产品经理' },
  { value: '产品助理', label: '产品助理' },
  { value: '产品设计经理', label: '产品设计经理' },
  { value: '增长产品经理', label: '增长产品经理' },
  { value: '商业产品经理', label: '商业产品经理' },
  { value: '数据产品经理', label: '数据产品经理' },
  { value: 'UX产品经理', label: 'UX产品经理' },

  // 六、设计类
  { value: 'UI设计师', label: 'UI设计师' },
  { value: 'UX设计师（用户体验）', label: 'UX设计师（用户体验）' },
  { value: '交互设计师', label: '交互设计师' },
  { value: '视觉设计师', label: '视觉设计师' },
  { value: '动效设计师', label: '动效设计师' },
  { value: '图标设计师', label: '图标设计师' },
  { value: '品牌设计师', label: '品牌设计师' },
  { value: 'UI开发工程师（切图/还原）', label: 'UI开发工程师（切图/还原）' },

  // 七、运营类
  { value: '运营经理', label: '运营经理' },
  { value: '内容运营', label: '内容运营' },
  { value: '用户运营', label: '用户运营' },
  { value: '活动运营', label: '活动运营' },
  { value: '社群运营', label: '社群运营' },
  { value: '产品运营', label: '产品运营' },

  // 八、市场/品牌类
  { value: '市场经理', label: '市场经理' },
  { value: '品牌经理', label: '品牌经理' },
  { value: '数字营销专员', label: '数字营销专员' },
  { value: 'SEO专员', label: 'SEO专员' },
  { value: 'SEM专员', label: 'SEM专员' },
  { value: '新媒体运营', label: '新媒体运营' },
  { value: '公关专员', label: '公关专员' },
  { value: '广告投放专员', label: '广告投放专员' },

  // 九、销售/商务类
  { value: '销售经理', label: '销售经理' },
  { value: '客户成功经理', label: '客户成功经理' },
  { value: '商务拓展（BD）', label: '商务拓展（BD）' },
  { value: '渠道经理', label: '渠道经理' },
  { value: '售前工程师', label: '售前工程师' },
  { value: '售后工程师', label: '售后工程师' },

  // 十、职能支持类
  { value: '人力资源专员', label: '人力资源专员' },
  { value: '人力资源经理', label: '人力资源经理' },
  { value: '招聘专员', label: '招聘专员' },
  { value: '行政专员', label: '行政专员' },
  { value: '财务专员', label: '财务专员' },
  { value: '法务专员', label: '法务专员' },
  { value: '项目经理（PM）', label: '项目经理（PM）' },
  { value: '办公室主任', label: '办公室主任' },
];
